/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.agent-message.error': 'Recharger le chat',
  'ai-mate.agent-message.error.aup-link-text': "Politique d'utilisation acceptable",
  'ai-mate.agent-message.error.aup-one': 'Impossible de répondre à ce prompt.',
  'ai-mate.agent-message.error.aup-two': 'Votre prompt peut ne pas être conforme à notre {link}. Essayez-en un autre.',
  'ai-mate.agent-message.error.copy-trace-id': "Copier l'ID de trace",
  'ai-mate.agent-message.error.network-error': 'Il semble y avoir un problème de réseau.',
  'ai-mate.agent-message.error.resend': 'Renvoyer le message',
  'ai-mate.agent-message.error.trace-id': 'ID de trace : {traceId}',
  'ai-mate.browse-agents-view.close-button': 'Fermer la vue des agents',
  'ai-mate.browse-agents-view.header-title': 'Parcourir les agents',
  'ai-mate.chat-history.conversationLimit':
    "Vous recherchez une ancienne conversation ? Nous effaçons l'historique des conversations après 30 jours pour assurer le bon fonctionnement d'Atlassian Intelligence.",
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': 'À quelles pages Confluence ai-je contribué récemment ?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': 'Trouver tous les tickets Jira qui me sont assignés.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': 'Quelle est notre politique en matière de déplacements ?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4':
    'Rédiger un brouillon de page Confluence pour une campagne marketing.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': 'Comment créer un calendrier de projet ?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': 'Écrire un e-mail de suivi à des clients potentiels.',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': 'Parcourir les agents',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': 'Discuter avec un agent Rovo',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': 'À propos de cet espace',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': 'Informations sur cet espace',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': "Suggestion d'espace",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1':
    "Y a-t-il de nouvelles activités sur les pages que j'ai écrites ?",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10':
    "Est-ce que `personne` a commenté les pages que j'ai publiées ?",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11':
    'Quels sont les principaux points à retenir de `page` ?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2':
    'Y a-t-il de nouveaux commentaires où mon nom est mentionné ?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3':
    'Résumer les pages les plus récemment publiées dans cet espace.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4':
    'Résumer mes contributions aux pages de la semaine dernière.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5':
    'Pouvez-vous réécrire `page` dans un langage moins technique ?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6':
    "Créer un modèle de plan d'attaque pour la gestion de projet.",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7':
    'De quelles recherches disposons-nous sur les problèmes courants des clients ?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8':
    'Un membre de mon équipe a-t-il publié de nouvelles pages cette semaine ?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9':
    'Est-ce que `personne` a publié de nouvelles pages cette semaine ?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1':
    'Pouvez-vous améliorer la rédaction de cette page ?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': 'Rédigez une synthèse de cette page.',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3':
    "Fournissez-moi des liens vers d'autres pages pertinentes.",
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': 'À propos de cette page',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': 'En savoir plus sur le contenu de cette page',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': 'Suggestion de page',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': 'Pouvez-vous résumer ce que je vois ?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': 'Résumez les commentaires sur cette page.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3':
    "M'expliquer cette page comme si j'étais un novice.",
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4':
    'Qui a rédigé cette page et de quelle équipe fait-il partie ?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5':
    'Est-ce que quelque chose a changé sur cette page la semaine dernière ?',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': 'À propos de ce tableau blanc',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': 'Autres avantages de ce tableau blanc',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': 'Informations sur ce tableau blanc',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': 'Pouvez-vous résumer ce que je vois ?',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2':
    'Mettez en évidence les modèles ou tendances visibles ici.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3':
    "Identifiez les éléments d'action ou les décisions clés qui figurent sur ce tableau blanc.",
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': 'Être productif',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': 'Rédiger du contenu',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': 'Trouver des informations',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': 'Rechercher des personnes',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': 'Obtenir des réponses',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': 'Mesurer la productivité',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': 'Reformuler du contenu',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': 'Se tenir informé',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': 'Résumer du contenu',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>par</text> {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': 'Bonjour {userName}',
  'ai-mate.chat-history.empty-state.intro-text-link-text': 'Découvrir Rovo Chat et les agents',
  'ai-mate.chat-history.empty-state.intro-text-subheadline':
    'Choisissez un prompt pour engager la conversation ou posez-moi une question.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': 'Recherchez des tickets Jira mis à jour cette semaine.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh':
    'Recherchez des tickets Jira mis à jour cette semaine.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': 'Quels tickets Jira ont la priorité la plus élevée ?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh':
    'Quels tickets Jira ont la priorité la plus élevée ?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3':
    'Quels tickets Jira contiennent des commentaires où mon nom est mentionné ?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh':
    'Quels tickets Jira contiennent des commentaires où mon nom est mentionné ?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': 'Résumer les commentaires sur `ticket Jira`.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh':
    'Résumer les commentaires sur `ticket Jira`.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': 'Créer un modèle de description pour les user stories.',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': 'À propos de ce ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': 'À propos de ce ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': 'En savoir plus sur le contenu de ce ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh':
    'En savoir plus sur le contenu de ce ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': 'Informations sur ce ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': 'Informations sur ce ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': 'Suggestion de ticket',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': 'Suggestion de ticket',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': 'Y a-t-il des tickets Jira similaires à celui-ci ?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh':
    'Y a-t-il des tickets Jira similaires à celui-ci ?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': 'Comment puis-je améliorer la description ?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': 'Quelles étiquettes puis-je ajouter à ce ticket ?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh':
    'Quelles étiquettes puis-je ajouter à ce ticket ?',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': 'À propos de ce projet',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': 'Informations sur ce projet',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': 'En savoir plus sur le contenu de ce projet',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': 'Suggestion de projet',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': "Quel ticket n'a pas été pris en charge depuis longtemps ?",
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': 'Rechercher et regrouper des tickets Jira similaires.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh':
    'Rechercher et regrouper des tickets Jira similaires.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11':
    'Y a-t-il des tickets Jira qui ne sont pas connectés à un ticket parent ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    'Y a-t-il des tickets Jira qui ne sont pas connectés à un ticket parent ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12':
    'Aligner la description de `ticket Jira` sur les bonnes pratiques.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    'Aligner la description de `ticket Jira` sur les bonnes pratiques.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': 'Résumer les commentaires sur `ticket Jira`.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    'Résumer les commentaires sur `ticket Jira`.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': 'Créer un modèle de description pour les user stories.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh':
    'Créer un modèle de description pour les user stories.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': 'Y a-t-il des tickets Jira bloqués ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh': 'Y a-t-il des tickets Jira bloqués ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    'Répertorier les tickets actuellement « En cours » et les regrouper par personne assignée.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    'Répertorier les tickets actuellement « En cours » et les regrouper par personne assignée.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': 'Combien de tickets sont assignés à `personne` ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh':
    'Combien de tickets sont assignés à [personne] ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5':
    'Est-ce que `personne` a commenté des tickets Jira dans ce sprint ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    'Est-ce que `personne` a commenté des tickets Jira dans ce sprint ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': 'Quels tickets Jira ne sont pas assignés ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh':
    'Quels tickets Jira ne sont pas assignés ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7':
    'Quels tickets Jira sont ouverts depuis le plus longtemps ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    'Quels tickets Jira sont ouverts depuis le plus longtemps ?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': 'Qui a le plus de tâches ?',
  'ai-mate.chat-history.empty-state.message':
    'Obtenez des réponses, générez de nouvelles idées et accélérez le travail quotidien.',
  'ai-mate.chat-history.empty-state.suggestion1': 'Certains de mes tickets sont-ils en retard ?',
  'ai-mate.chat-history.empty-state.suggestion2': 'Sur quoi devrais-je travailler ensuite ?',
  'ai-mate.chat-history.empty-state.suggestion3': 'Rédiger une mise à jour sur ma semaine',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': 'Suggestion',
  'ai-mate.chat-history.message-research.research-completed-notification-body':
    'Votre recherche est terminée et prête à être consultée.',
  'ai-mate.chat-history.message-research.research-completed-notification-title': 'Rovo Chat a terminé ses recherches',
  'ai-mate.chat-history.message-research.research-expandable.collapse': 'Réduire',
  'ai-mate.chat-history.message-research.research-expandable.expand': 'Développer',
  'ai-mate.chat-history.message-research.research-step-title-placeholder': "Recherche d'informations pertinentes...",
  'ai-mate.chat-history.message-research.sources-title': '{count, plural, one {1 source} other {{count} sources}}',
  'ai-mate.chat-history.message-research.title': 'Recherche approfondie',
  'ai-mate.chat-history.message-research.view-sources-button-label':
    '{count, plural, one {1 source} other {{count} sources}}',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'Annuler',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': 'Confirmer',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button':
    'Un problème est survenu lors de la réalisation de cette action',
  'ai-mate.chat-input.actions-button.label': 'Insérer des éléments',
  'ai-mate.chat-input.add-a-link-button.label': 'Ajouter un lien',
  'ai-mate.chat-input.deep-research-button.label': 'Recherche approfondie',
  'ai-mate.chat-input.deleted-agent-icon-label': 'Agent supprimé',
  'ai-mate.chat-input.deleted-agent-start-new-chat': 'Démarrer un nouveau chat',
  'ai-mate.chat-input.deleted-agent-warning': 'Cet agent a été supprimé.',
  'ai-mate.chat-input.drag-and-drop-message':
    'Glissez-déposez pour ajouter du contexte et obtenir de meilleurs résultats',
  'ai-mate.chat-input.file-close-icon-label': 'Supprimer le fichier',
  'ai-mate.chat-input.file-error-icon-label': 'Erreur de chargement du fichier',
  'ai-mate.chat-input.link-type-ahead-button.label': 'Ajouter un lien',
  'ai-mate.chat-input.mention-someone-button.label': "Mentionner quelqu'un ou une équipe",
  'ai-mate.chat-input.mention-type-ahead-button.label': "Mentionner quelqu'un",
  'ai-mate.chat-input.open-chat-input-buttons-label': 'Boutons permettant de saisir du texte dans le chat',
  'ai-mate.chat-input.send-button.label': 'Envoyer',
  'ai-mate.chat-input.stop-generating-button.label': 'Arrêter la génération',
  'ai-mate.chat-input.store-user-messages.label':
    'Enregistrez ce message pour nous aider à améliorer la qualité des réponses',
  'ai-mate.chat-input.web-search-button.label': 'Rechercher',
  'ai-mate.chat-main-header.back-button.label': 'Retour',
  'ai-mate.chat-main-header.copy-agent-link-button.label': 'Copier le lien',
  'ai-mate.chat-main-header.default-agent-name': 'Chat',
  'ai-mate.chat-main-header.edit-agent-button.label': 'Modifier',
  'ai-mate.chat-main-header.link-copied-to-profile': 'URL copiée',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Supprimer',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Renommer',
  'ai-mate.chat-view.chat-item.options-button-label': 'Options de chat',
  'ai-mate.content-renderer.profile-card.view-profile-button': 'Afficher le profil',
  'ai-mate.content-renderer.view-code-button-label': "Voir l'analyse",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Annuler',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    "La conversation que vous essayez de supprimer n'existe pas.",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Supprimer',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Supprimer la conversation « {name} » ?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    "Une erreur s'est produite lors de la suppression de cette conversation. Veuillez réessayer.",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Voulez-vous vraiment supprimer cette conversation ? Cette action est irréversible.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Annuler',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    "Le canal que vous essayez de modifier n'existe pas.",
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Nom',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    "Une erreur s'est produite lors de la modification de cette conversation. Veuillez réessayer.",
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Modifier la conversation',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Le nom est le même que le nom actuel.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Enregistrer',
  'ai-mate.conversation-list-view.back-button.label': 'Retour',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Fermer le chat',
  'ai-mate.conversation-list-view.header-title': 'Historique du chat',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Nouveau chat',
  'ai-mate.conversation-list-view.no-chat': 'Aucun résultat',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Recherchez des chats',
  'ai-mate.expander.hide-details': 'Masquer les informations',
  'ai-mate.expander.show-details': "Afficher plus d'informations",
  'ai-mate.footer.beta': 'BÊTA',
  'ai-mate.footer.info': 'La qualité du contenu est susceptible de varier',
  'ai-mate.footer.info-truncated': 'La qualité du contenu est susceptible de varier',
  'ai-mate.footer.info-updated': 'Le contenu est basé sur vos autorisations, et sa qualité peut varier',
  'ai-mate.footer.rovo-branding-label': 'Rovo {logo}',
  'ai-mate.footer.rovo-branding-label-updated': '{logo} Rovo',
  'ai-mate.message-renderer.error': 'Contactez-nous si le problème persiste.',
  'ai-mate.message-renderer.error-title': 'Échec du chargement du contenu',
  'ai-mate.message-renderer.hide-sources': 'Masquer toutes les sources',
  'ai-mate.message-renderer.show-sources':
    '{count, plural, one {Afficher {count} source} other {Afficher {count} sources}}',
  'ai-mate.message-renderer.sources.sources-title': 'Sources',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': 'Confirmation impossible, réessayez dans quelques instants.',
  'ai-mate.pubsub-listener.forge-auth-success-message': 'Autorisation confirmée, renvoyez votre prompt.',
  'ai-mate.sidebar.agents-icon.text': 'Agents',
  'ai-mate.sidebar.agents-icon.tooltip': 'Parcourir les agents Rovo',
  'ai-mate.sidebar.chat-icon.text': 'Chat',
  'ai-mate.sidebar.chat-icon.tooltip': 'Chat avec Rovo',
  'ai-mate.sidebar.debug-mode-icon.tooltip': 'Déboguer',
  'ai-mate.sidebar.get-help-icon.tooltip': "Obtenir de l'aide",
  'ai-mate.sidebar.give-feedback-icon.tooltip': 'Donner votre avis',
  'ai-mate.sidebar.history-icon.text': 'Historique',
  'ai-mate.sidebar.history-icon.tooltip': 'Afficher votre historique de chat',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-description':
    'Une erreur est survenue lors de la validation des fichiers. Veuillez réessayer.',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-title': 'Impossible de valider les fichiers',
  'ai-mate.upload-files-to-conversation.file-invalid-icon-label': "Le fichier n'est pas valide",
  'ai-mate.upload-files-to-conversation.invalid-files-description':
    "{count, plural, one {Le fichier « {fileNames} » n'est pas pris en charge. Motif : {reasons}} other {Les fichiers « {fileNames} » ne sont pas pris en charge. Motifs : {reasons}}}",
  'ai-mate.upload-files-to-conversation.invalid-files-title':
    '{count, plural, one {{count,number} type de fichier non pris en charge} other {{count,number} types de fichier non pris en charge}}',
  'ai-mate.upload-files-to-conversation.unknown-error':
    'Une erreur est survenue lors du chargement du fichier. Veuillez réessayer.',
  'ai-mate.upload-files-to-conversation.unsupported-file': 'Type de fichier non pris en charge',
  'ai-mate.upload-files-to-conversation.validation-error-file-name-missing': 'Nom du fichier manquant',
  'ai-mate.upload-files-to-conversation.validation-error-file-too-large': 'Fichier trop lourd',
  'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type': 'Type de fichier non pris en charge',
  'ai-mate.upload-files-to-conversation.validation-error-missing-error-code': 'Résultat de validation inconnu',
  'ai-mate.upload-files-to-conversation.validation-error-not-found': 'Résultat de validation introuvable',
  'ai-mate.upload-files-to-conversation.validation-error-unknown-error':
    'Impossible de valider le fichier pour une raison inconnue',
  'chat-history.rate-limit-warning':
    '{secondsRemaining, plural, one {Veuillez patienter {secondsRemaining,number} seconde} other {Veuillez patienter {secondsRemaining,number} secondes}}',
  'chat-history.rate-limit-warning-description': 'Les messages sont envoyés trop vite, veuillez patienter.',
  'chatHistory.storeAssistant.badResponseLabel': 'Mauvaise réponse',
  'chatHistory.storeAssistant.copyResponseLabel': 'Copier',
  'chatHistory.storeAssistant.goodResponseLabel': 'Bonne réponse',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': 'Utiliser ce contexte',
  'rovo-chat.data-sculptor-modal.cancel': 'Annuler',
  'rovo-chat.data-sculptor-modal.no-data': 'Aucune donnée',
  'rovo-chat.data-sculptor-modal.title': 'Analyse',
  'rovo-chat.file-upload-button.label': 'Télécharger un fichier',
  'rovo-chat.file-upload-button.max-files-label':
    '{maxFiles, plural, one {Limite de {maxFiles,number} fichier atteinte} other {Limite de {maxFiles,number} fichiers atteinte}}',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Glissez-déposez pour ajouter du contexte',
  'rovo-chat.message-file.icon-label': 'Fichier',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': 'Insérer dans la page',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': 'Insérer',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': 'Insérer dans le ticket',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': 'Remplacer la sélection',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    "Cette fonctionnalité n'est pas prise en charge dans votre contexte actuel. Essayez de sélectionner, d'écrire ou de modifier du texte sur la page.",
  'rovo-chat.store-assistant.sources-title': 'Sources :',
};
